/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./../routes/__root";
import { Route as IndexRouteImport } from "./../routes/index";
import { Route as AppRouteImport } from "./../routes/_app";
import { Route as AcceptInviteRouteImport } from "./../routes/accept-invite";
import { Route as ForgotPasswordRouteImport } from "./../routes/forgot-password";
import { Route as ResetPasswordRouteImport } from "./../routes/reset-password";
import { Route as SigninRouteImport } from "./../routes/signin";
import { Route as AppRegionRouteImport } from "./../routes/_app/$region";
import { Route as AppAboutRouteImport } from "./../routes/_app/about";
import { Route as AppAccountRouteImport } from "./../routes/_app/account";
import { Route as AppRegionIndexRouteImport } from "./../routes/_app/$region/index";
import { Route as AppRegionAssistantRouteImport } from "./../routes/_app/$region/assistant";
import { Route as AppRegionCurvesRouteImport } from "./../routes/_app/$region/curves";
import { Route as AppRegionGlossaryRouteImport } from "./../routes/_app/$region/glossary";
import { Route as AppRegionParametersRouteImport } from "./../routes/_app/$region/parameters";
import { Route as AppRegionQualityRouteImport } from "./../routes/_app/$region/quality";
import { Route as AppRegionSearchRouteImport } from "./../routes/_app/$region/search";
import { Route as AppRegionVersionsRouteImport } from "./../routes/_app/$region/versions";
import { Route as AppRegionWorkspaceRouteImport } from "./../routes/_app/$region/workspace";
import { Route as AppAdminDatasetsRouteImport } from "./../routes/_app/admin/datasets";
import { Route as AppAdminFeedbackRouteImport } from "./../routes/_app/admin/feedback";
import { Route as AppAdminSettingsRouteImport } from "./../routes/_app/admin/settings";
import { Route as AppAdminUsersRouteImport } from "./../routes/_app/admin/users";
import { Route as AppOpsSourcesRouteImport } from "./../routes/_app/ops/sources";
import { Route as AppOpsSystemRouteImport } from "./../routes/_app/ops/system";
import { Route as AppRegionAssessmentsIndexRouteImport } from "./../routes/_app/$region/assessments.index";
import { Route as AppRegionAssessmentsAssessmentUidRouteImport } from "./../routes/_app/$region/assessments.$assessmentUid";
import { Route as AppRegionAssessmentsNewRouteImport } from "./../routes/_app/$region/assessments.new";
import { Route as AppRegionCurvesChartKeyRouteImport } from "./../routes/_app/$region/curves_.$chartKey";
import { Route as AppRegionLibraryIndexRouteImport } from "./../routes/_app/$region/library/index";
import { Route as AppRegionLibraryDocUidRouteImport } from "./../routes/_app/$region/library/$docUid";
import { Route as AppAdminDatasetsIndexRouteImport } from "./../routes/_app/admin/datasets.index";
import { Route as AppAdminDatasetsActivityRouteImport } from "./../routes/_app/admin/datasets.activity";
import { Route as AppAdminDatasetsFilesRouteImport } from "./../routes/_app/admin/datasets.files";
import { Route as AppAdminDatasetsNewRouteImport } from "./../routes/_app/admin/datasets.new";
import { Route as AppAdminDatasetsRegistryRouteImport } from "./../routes/_app/admin/datasets.registry";
import { Route as AppOpsJobsIndexRouteImport } from "./../routes/_app/ops/jobs.index";
import { Route as AppOpsJobsJobIdRouteImport } from "./../routes/_app/ops/jobs.$jobId";
import { Route as AppOpsRunsIndexRouteImport } from "./../routes/_app/ops/runs.index";
import { Route as AppOpsRunsRunUidRouteImport } from "./../routes/_app/ops/runs.$runUid";
import { Route as AppRegionAssessmentsDocumentsCapabilityDocUidRouteImport } from "./../routes/_app/$region/assessments.documents.$capabilityDocUid";
import { Route as AppRegionLibraryDocUidPdfRouteImport } from "./../routes/_app/$region/library/$docUid_.pdf";
import { Route as AppAdminDatasetsFamiliesFamilyIdIndexRouteImport } from "./../routes/_app/admin/datasets.families.$familyId.index";
import { Route as AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRouteImport } from "./../routes/_app/admin/datasets.families.$familyId.versions.$versionLabel";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: "/accept-invite",
  path: "/accept-invite",
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any);
const SigninRoute = SigninRouteImport.update({
  id: "/signin",
  path: "/signin",
  getParentRoute: () => rootRouteImport,
} as any);
const AppRegionRoute = AppRegionRouteImport.update({
  id: "/$region",
  path: "/$region",
  getParentRoute: () => AppRoute,
} as any);
const AppAboutRoute = AppAboutRouteImport.update({
  id: "/about",
  path: "/about",
  getParentRoute: () => AppRoute,
} as any);
const AppAccountRoute = AppAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AppRoute,
} as any);
const AppRegionIndexRoute = AppRegionIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionAssistantRoute = AppRegionAssistantRouteImport.update({
  id: "/assistant",
  path: "/assistant",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionCurvesRoute = AppRegionCurvesRouteImport.update({
  id: "/curves",
  path: "/curves",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionGlossaryRoute = AppRegionGlossaryRouteImport.update({
  id: "/glossary",
  path: "/glossary",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionParametersRoute = AppRegionParametersRouteImport.update({
  id: "/parameters",
  path: "/parameters",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionQualityRoute = AppRegionQualityRouteImport.update({
  id: "/quality",
  path: "/quality",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionSearchRoute = AppRegionSearchRouteImport.update({
  id: "/search",
  path: "/search",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionVersionsRoute = AppRegionVersionsRouteImport.update({
  id: "/versions",
  path: "/versions",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionWorkspaceRoute = AppRegionWorkspaceRouteImport.update({
  id: "/workspace",
  path: "/workspace",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppAdminDatasetsRoute = AppAdminDatasetsRouteImport.update({
  id: "/admin/datasets",
  path: "/admin/datasets",
  getParentRoute: () => AppRoute,
} as any);
const AppAdminFeedbackRoute = AppAdminFeedbackRouteImport.update({
  id: "/admin/feedback",
  path: "/admin/feedback",
  getParentRoute: () => AppRoute,
} as any);
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: "/admin/settings",
  path: "/admin/settings",
  getParentRoute: () => AppRoute,
} as any);
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: "/admin/users",
  path: "/admin/users",
  getParentRoute: () => AppRoute,
} as any);
const AppOpsSourcesRoute = AppOpsSourcesRouteImport.update({
  id: "/ops/sources",
  path: "/ops/sources",
  getParentRoute: () => AppRoute,
} as any);
const AppOpsSystemRoute = AppOpsSystemRouteImport.update({
  id: "/ops/system",
  path: "/ops/system",
  getParentRoute: () => AppRoute,
} as any);
const AppRegionAssessmentsIndexRoute =
  AppRegionAssessmentsIndexRouteImport.update({
    id: "/assessments/",
    path: "/assessments/",
    getParentRoute: () => AppRegionRoute,
  } as any);
const AppRegionAssessmentsAssessmentUidRoute =
  AppRegionAssessmentsAssessmentUidRouteImport.update({
    id: "/assessments/$assessmentUid",
    path: "/assessments/$assessmentUid",
    getParentRoute: () => AppRegionRoute,
  } as any);
const AppRegionAssessmentsNewRoute = AppRegionAssessmentsNewRouteImport.update({
  id: "/assessments/new",
  path: "/assessments/new",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionCurvesChartKeyRoute = AppRegionCurvesChartKeyRouteImport.update({
  id: "/curves_/$chartKey",
  path: "/curves/$chartKey",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionLibraryIndexRoute = AppRegionLibraryIndexRouteImport.update({
  id: "/library/",
  path: "/library/",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppRegionLibraryDocUidRoute = AppRegionLibraryDocUidRouteImport.update({
  id: "/library/$docUid",
  path: "/library/$docUid",
  getParentRoute: () => AppRegionRoute,
} as any);
const AppAdminDatasetsIndexRoute = AppAdminDatasetsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppAdminDatasetsRoute,
} as any);
const AppAdminDatasetsActivityRoute =
  AppAdminDatasetsActivityRouteImport.update({
    id: "/activity",
    path: "/activity",
    getParentRoute: () => AppAdminDatasetsRoute,
  } as any);
const AppAdminDatasetsFilesRoute = AppAdminDatasetsFilesRouteImport.update({
  id: "/files",
  path: "/files",
  getParentRoute: () => AppAdminDatasetsRoute,
} as any);
const AppAdminDatasetsNewRoute = AppAdminDatasetsNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AppAdminDatasetsRoute,
} as any);
const AppAdminDatasetsRegistryRoute =
  AppAdminDatasetsRegistryRouteImport.update({
    id: "/registry",
    path: "/registry",
    getParentRoute: () => AppAdminDatasetsRoute,
  } as any);
const AppOpsJobsIndexRoute = AppOpsJobsIndexRouteImport.update({
  id: "/ops/jobs/",
  path: "/ops/jobs/",
  getParentRoute: () => AppRoute,
} as any);
const AppOpsJobsJobIdRoute = AppOpsJobsJobIdRouteImport.update({
  id: "/ops/jobs/$jobId",
  path: "/ops/jobs/$jobId",
  getParentRoute: () => AppRoute,
} as any);
const AppOpsRunsIndexRoute = AppOpsRunsIndexRouteImport.update({
  id: "/ops/runs/",
  path: "/ops/runs/",
  getParentRoute: () => AppRoute,
} as any);
const AppOpsRunsRunUidRoute = AppOpsRunsRunUidRouteImport.update({
  id: "/ops/runs/$runUid",
  path: "/ops/runs/$runUid",
  getParentRoute: () => AppRoute,
} as any);
const AppRegionAssessmentsDocumentsCapabilityDocUidRoute =
  AppRegionAssessmentsDocumentsCapabilityDocUidRouteImport.update({
    id: "/assessments/documents/$capabilityDocUid",
    path: "/assessments/documents/$capabilityDocUid",
    getParentRoute: () => AppRegionRoute,
  } as any);
const AppRegionLibraryDocUidPdfRoute =
  AppRegionLibraryDocUidPdfRouteImport.update({
    id: "/library/$docUid_/pdf",
    path: "/library/$docUid/pdf",
    getParentRoute: () => AppRegionRoute,
  } as any);
const AppAdminDatasetsFamiliesFamilyIdIndexRoute =
  AppAdminDatasetsFamiliesFamilyIdIndexRouteImport.update({
    id: "/families/$familyId/",
    path: "/families/$familyId/",
    getParentRoute: () => AppAdminDatasetsRoute,
  } as any);
const AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRoute =
  AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRouteImport.update({
    id: "/families/$familyId/versions/$versionLabel",
    path: "/families/$familyId/versions/$versionLabel",
    getParentRoute: () => AppAdminDatasetsRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/accept-invite": typeof AcceptInviteRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/signin": typeof SigninRoute;
  "/$region": typeof AppRegionRouteWithChildren;
  "/about": typeof AppAboutRoute;
  "/account": typeof AppAccountRoute;
  "/$region/assistant": typeof AppRegionAssistantRoute;
  "/$region/curves": typeof AppRegionCurvesRoute;
  "/$region/glossary": typeof AppRegionGlossaryRoute;
  "/$region/parameters": typeof AppRegionParametersRoute;
  "/$region/quality": typeof AppRegionQualityRoute;
  "/$region/search": typeof AppRegionSearchRoute;
  "/$region/versions": typeof AppRegionVersionsRoute;
  "/$region/workspace": typeof AppRegionWorkspaceRoute;
  "/admin/datasets": typeof AppAdminDatasetsRouteWithChildren;
  "/admin/feedback": typeof AppAdminFeedbackRoute;
  "/admin/settings": typeof AppAdminSettingsRoute;
  "/admin/users": typeof AppAdminUsersRoute;
  "/ops/sources": typeof AppOpsSourcesRoute;
  "/ops/system": typeof AppOpsSystemRoute;
  "/$region/": typeof AppRegionIndexRoute;
  "/$region/assessments/$assessmentUid": typeof AppRegionAssessmentsAssessmentUidRoute;
  "/$region/assessments/new": typeof AppRegionAssessmentsNewRoute;
  "/$region/curves/$chartKey": typeof AppRegionCurvesChartKeyRoute;
  "/$region/library/$docUid": typeof AppRegionLibraryDocUidRoute;
  "/admin/datasets/activity": typeof AppAdminDatasetsActivityRoute;
  "/admin/datasets/files": typeof AppAdminDatasetsFilesRoute;
  "/admin/datasets/new": typeof AppAdminDatasetsNewRoute;
  "/admin/datasets/registry": typeof AppAdminDatasetsRegistryRoute;
  "/ops/jobs/$jobId": typeof AppOpsJobsJobIdRoute;
  "/ops/runs/$runUid": typeof AppOpsRunsRunUidRoute;
  "/$region/assessments/": typeof AppRegionAssessmentsIndexRoute;
  "/$region/library/": typeof AppRegionLibraryIndexRoute;
  "/admin/datasets/": typeof AppAdminDatasetsIndexRoute;
  "/ops/jobs/": typeof AppOpsJobsIndexRoute;
  "/ops/runs/": typeof AppOpsRunsIndexRoute;
  "/$region/assessments/documents/$capabilityDocUid": typeof AppRegionAssessmentsDocumentsCapabilityDocUidRoute;
  "/$region/library/$docUid/pdf": typeof AppRegionLibraryDocUidPdfRoute;
  "/admin/datasets/families/$familyId/": typeof AppAdminDatasetsFamiliesFamilyIdIndexRoute;
  "/admin/datasets/families/$familyId/versions/$versionLabel": typeof AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/accept-invite": typeof AcceptInviteRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/signin": typeof SigninRoute;
  "/about": typeof AppAboutRoute;
  "/account": typeof AppAccountRoute;
  "/$region/assistant": typeof AppRegionAssistantRoute;
  "/$region/curves": typeof AppRegionCurvesRoute;
  "/$region/glossary": typeof AppRegionGlossaryRoute;
  "/$region/parameters": typeof AppRegionParametersRoute;
  "/$region/quality": typeof AppRegionQualityRoute;
  "/$region/search": typeof AppRegionSearchRoute;
  "/$region/versions": typeof AppRegionVersionsRoute;
  "/$region/workspace": typeof AppRegionWorkspaceRoute;
  "/admin/feedback": typeof AppAdminFeedbackRoute;
  "/admin/settings": typeof AppAdminSettingsRoute;
  "/admin/users": typeof AppAdminUsersRoute;
  "/ops/sources": typeof AppOpsSourcesRoute;
  "/ops/system": typeof AppOpsSystemRoute;
  "/$region": typeof AppRegionIndexRoute;
  "/$region/assessments/$assessmentUid": typeof AppRegionAssessmentsAssessmentUidRoute;
  "/$region/assessments/new": typeof AppRegionAssessmentsNewRoute;
  "/$region/curves/$chartKey": typeof AppRegionCurvesChartKeyRoute;
  "/$region/library/$docUid": typeof AppRegionLibraryDocUidRoute;
  "/admin/datasets/activity": typeof AppAdminDatasetsActivityRoute;
  "/admin/datasets/files": typeof AppAdminDatasetsFilesRoute;
  "/admin/datasets/new": typeof AppAdminDatasetsNewRoute;
  "/admin/datasets/registry": typeof AppAdminDatasetsRegistryRoute;
  "/ops/jobs/$jobId": typeof AppOpsJobsJobIdRoute;
  "/ops/runs/$runUid": typeof AppOpsRunsRunUidRoute;
  "/$region/assessments": typeof AppRegionAssessmentsIndexRoute;
  "/$region/library": typeof AppRegionLibraryIndexRoute;
  "/admin/datasets": typeof AppAdminDatasetsIndexRoute;
  "/ops/jobs": typeof AppOpsJobsIndexRoute;
  "/ops/runs": typeof AppOpsRunsIndexRoute;
  "/$region/assessments/documents/$capabilityDocUid": typeof AppRegionAssessmentsDocumentsCapabilityDocUidRoute;
  "/$region/library/$docUid/pdf": typeof AppRegionLibraryDocUidPdfRoute;
  "/admin/datasets/families/$familyId": typeof AppAdminDatasetsFamiliesFamilyIdIndexRoute;
  "/admin/datasets/families/$familyId/versions/$versionLabel": typeof AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_app": typeof AppRouteWithChildren;
  "/accept-invite": typeof AcceptInviteRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/signin": typeof SigninRoute;
  "/_app/$region": typeof AppRegionRouteWithChildren;
  "/_app/about": typeof AppAboutRoute;
  "/_app/account": typeof AppAccountRoute;
  "/_app/$region/assistant": typeof AppRegionAssistantRoute;
  "/_app/$region/curves": typeof AppRegionCurvesRoute;
  "/_app/$region/glossary": typeof AppRegionGlossaryRoute;
  "/_app/$region/parameters": typeof AppRegionParametersRoute;
  "/_app/$region/quality": typeof AppRegionQualityRoute;
  "/_app/$region/search": typeof AppRegionSearchRoute;
  "/_app/$region/versions": typeof AppRegionVersionsRoute;
  "/_app/$region/workspace": typeof AppRegionWorkspaceRoute;
  "/_app/admin/datasets": typeof AppAdminDatasetsRouteWithChildren;
  "/_app/admin/feedback": typeof AppAdminFeedbackRoute;
  "/_app/admin/settings": typeof AppAdminSettingsRoute;
  "/_app/admin/users": typeof AppAdminUsersRoute;
  "/_app/ops/sources": typeof AppOpsSourcesRoute;
  "/_app/ops/system": typeof AppOpsSystemRoute;
  "/_app/$region/": typeof AppRegionIndexRoute;
  "/_app/$region/assessments/$assessmentUid": typeof AppRegionAssessmentsAssessmentUidRoute;
  "/_app/$region/assessments/new": typeof AppRegionAssessmentsNewRoute;
  "/_app/$region/curves_/$chartKey": typeof AppRegionCurvesChartKeyRoute;
  "/_app/$region/library/$docUid": typeof AppRegionLibraryDocUidRoute;
  "/_app/admin/datasets/activity": typeof AppAdminDatasetsActivityRoute;
  "/_app/admin/datasets/files": typeof AppAdminDatasetsFilesRoute;
  "/_app/admin/datasets/new": typeof AppAdminDatasetsNewRoute;
  "/_app/admin/datasets/registry": typeof AppAdminDatasetsRegistryRoute;
  "/_app/ops/jobs/$jobId": typeof AppOpsJobsJobIdRoute;
  "/_app/ops/runs/$runUid": typeof AppOpsRunsRunUidRoute;
  "/_app/$region/assessments/": typeof AppRegionAssessmentsIndexRoute;
  "/_app/$region/library/": typeof AppRegionLibraryIndexRoute;
  "/_app/admin/datasets/": typeof AppAdminDatasetsIndexRoute;
  "/_app/ops/jobs/": typeof AppOpsJobsIndexRoute;
  "/_app/ops/runs/": typeof AppOpsRunsIndexRoute;
  "/_app/$region/assessments/documents/$capabilityDocUid": typeof AppRegionAssessmentsDocumentsCapabilityDocUidRoute;
  "/_app/$region/library/$docUid_/pdf": typeof AppRegionLibraryDocUidPdfRoute;
  "/_app/admin/datasets/families/$familyId/": typeof AppAdminDatasetsFamiliesFamilyIdIndexRoute;
  "/_app/admin/datasets/families/$familyId/versions/$versionLabel": typeof AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/accept-invite"
    | "/forgot-password"
    | "/reset-password"
    | "/signin"
    | "/$region"
    | "/about"
    | "/account"
    | "/$region/assistant"
    | "/$region/curves"
    | "/$region/glossary"
    | "/$region/parameters"
    | "/$region/quality"
    | "/$region/search"
    | "/$region/versions"
    | "/$region/workspace"
    | "/admin/datasets"
    | "/admin/feedback"
    | "/admin/settings"
    | "/admin/users"
    | "/ops/sources"
    | "/ops/system"
    | "/$region/"
    | "/$region/assessments/$assessmentUid"
    | "/$region/assessments/new"
    | "/$region/curves/$chartKey"
    | "/$region/library/$docUid"
    | "/admin/datasets/activity"
    | "/admin/datasets/files"
    | "/admin/datasets/new"
    | "/admin/datasets/registry"
    | "/ops/jobs/$jobId"
    | "/ops/runs/$runUid"
    | "/$region/assessments/"
    | "/$region/library/"
    | "/admin/datasets/"
    | "/ops/jobs/"
    | "/ops/runs/"
    | "/$region/assessments/documents/$capabilityDocUid"
    | "/$region/library/$docUid/pdf"
    | "/admin/datasets/families/$familyId/"
    | "/admin/datasets/families/$familyId/versions/$versionLabel";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/accept-invite"
    | "/forgot-password"
    | "/reset-password"
    | "/signin"
    | "/about"
    | "/account"
    | "/$region/assistant"
    | "/$region/curves"
    | "/$region/glossary"
    | "/$region/parameters"
    | "/$region/quality"
    | "/$region/search"
    | "/$region/versions"
    | "/$region/workspace"
    | "/admin/feedback"
    | "/admin/settings"
    | "/admin/users"
    | "/ops/sources"
    | "/ops/system"
    | "/$region"
    | "/$region/assessments/$assessmentUid"
    | "/$region/assessments/new"
    | "/$region/curves/$chartKey"
    | "/$region/library/$docUid"
    | "/admin/datasets/activity"
    | "/admin/datasets/files"
    | "/admin/datasets/new"
    | "/admin/datasets/registry"
    | "/ops/jobs/$jobId"
    | "/ops/runs/$runUid"
    | "/$region/assessments"
    | "/$region/library"
    | "/admin/datasets"
    | "/ops/jobs"
    | "/ops/runs"
    | "/$region/assessments/documents/$capabilityDocUid"
    | "/$region/library/$docUid/pdf"
    | "/admin/datasets/families/$familyId"
    | "/admin/datasets/families/$familyId/versions/$versionLabel";
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/accept-invite"
    | "/forgot-password"
    | "/reset-password"
    | "/signin"
    | "/_app/$region"
    | "/_app/about"
    | "/_app/account"
    | "/_app/$region/assistant"
    | "/_app/$region/curves"
    | "/_app/$region/glossary"
    | "/_app/$region/parameters"
    | "/_app/$region/quality"
    | "/_app/$region/search"
    | "/_app/$region/versions"
    | "/_app/$region/workspace"
    | "/_app/admin/datasets"
    | "/_app/admin/feedback"
    | "/_app/admin/settings"
    | "/_app/admin/users"
    | "/_app/ops/sources"
    | "/_app/ops/system"
    | "/_app/$region/"
    | "/_app/$region/assessments/$assessmentUid"
    | "/_app/$region/assessments/new"
    | "/_app/$region/curves_/$chartKey"
    | "/_app/$region/library/$docUid"
    | "/_app/admin/datasets/activity"
    | "/_app/admin/datasets/files"
    | "/_app/admin/datasets/new"
    | "/_app/admin/datasets/registry"
    | "/_app/ops/jobs/$jobId"
    | "/_app/ops/runs/$runUid"
    | "/_app/$region/assessments/"
    | "/_app/$region/library/"
    | "/_app/admin/datasets/"
    | "/_app/ops/jobs/"
    | "/_app/ops/runs/"
    | "/_app/$region/assessments/documents/$capabilityDocUid"
    | "/_app/$region/library/$docUid_/pdf"
    | "/_app/admin/datasets/families/$familyId/"
    | "/_app/admin/datasets/families/$familyId/versions/$versionLabel";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  AcceptInviteRoute: typeof AcceptInviteRoute;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  SigninRoute: typeof SigninRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/accept-invite": {
      id: "/accept-invite";
      path: "/accept-invite";
      fullPath: "/accept-invite";
      preLoaderRoute: typeof AcceptInviteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/forgot-password": {
      id: "/forgot-password";
      path: "/forgot-password";
      fullPath: "/forgot-password";
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/reset-password": {
      id: "/reset-password";
      path: "/reset-password";
      fullPath: "/reset-password";
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signin": {
      id: "/signin";
      path: "/signin";
      fullPath: "/signin";
      preLoaderRoute: typeof SigninRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/$region": {
      id: "/_app/$region";
      path: "/$region";
      fullPath: "/$region";
      preLoaderRoute: typeof AppRegionRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/about": {
      id: "/_app/about";
      path: "/about";
      fullPath: "/about";
      preLoaderRoute: typeof AppAboutRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/account": {
      id: "/_app/account";
      path: "/account";
      fullPath: "/account";
      preLoaderRoute: typeof AppAccountRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/$region/": {
      id: "/_app/$region/";
      path: "/";
      fullPath: "/$region/";
      preLoaderRoute: typeof AppRegionIndexRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/assistant": {
      id: "/_app/$region/assistant";
      path: "/assistant";
      fullPath: "/$region/assistant";
      preLoaderRoute: typeof AppRegionAssistantRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/curves": {
      id: "/_app/$region/curves";
      path: "/curves";
      fullPath: "/$region/curves";
      preLoaderRoute: typeof AppRegionCurvesRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/glossary": {
      id: "/_app/$region/glossary";
      path: "/glossary";
      fullPath: "/$region/glossary";
      preLoaderRoute: typeof AppRegionGlossaryRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/parameters": {
      id: "/_app/$region/parameters";
      path: "/parameters";
      fullPath: "/$region/parameters";
      preLoaderRoute: typeof AppRegionParametersRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/quality": {
      id: "/_app/$region/quality";
      path: "/quality";
      fullPath: "/$region/quality";
      preLoaderRoute: typeof AppRegionQualityRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/search": {
      id: "/_app/$region/search";
      path: "/search";
      fullPath: "/$region/search";
      preLoaderRoute: typeof AppRegionSearchRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/versions": {
      id: "/_app/$region/versions";
      path: "/versions";
      fullPath: "/$region/versions";
      preLoaderRoute: typeof AppRegionVersionsRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/workspace": {
      id: "/_app/$region/workspace";
      path: "/workspace";
      fullPath: "/$region/workspace";
      preLoaderRoute: typeof AppRegionWorkspaceRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/admin/datasets": {
      id: "/_app/admin/datasets";
      path: "/admin/datasets";
      fullPath: "/admin/datasets";
      preLoaderRoute: typeof AppAdminDatasetsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/admin/feedback": {
      id: "/_app/admin/feedback";
      path: "/admin/feedback";
      fullPath: "/admin/feedback";
      preLoaderRoute: typeof AppAdminFeedbackRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/admin/settings": {
      id: "/_app/admin/settings";
      path: "/admin/settings";
      fullPath: "/admin/settings";
      preLoaderRoute: typeof AppAdminSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/admin/users": {
      id: "/_app/admin/users";
      path: "/admin/users";
      fullPath: "/admin/users";
      preLoaderRoute: typeof AppAdminUsersRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ops/sources": {
      id: "/_app/ops/sources";
      path: "/ops/sources";
      fullPath: "/ops/sources";
      preLoaderRoute: typeof AppOpsSourcesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ops/system": {
      id: "/_app/ops/system";
      path: "/ops/system";
      fullPath: "/ops/system";
      preLoaderRoute: typeof AppOpsSystemRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/$region/assessments/": {
      id: "/_app/$region/assessments/";
      path: "/assessments";
      fullPath: "/$region/assessments/";
      preLoaderRoute: typeof AppRegionAssessmentsIndexRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/assessments/$assessmentUid": {
      id: "/_app/$region/assessments/$assessmentUid";
      path: "/assessments/$assessmentUid";
      fullPath: "/$region/assessments/$assessmentUid";
      preLoaderRoute: typeof AppRegionAssessmentsAssessmentUidRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/assessments/new": {
      id: "/_app/$region/assessments/new";
      path: "/assessments/new";
      fullPath: "/$region/assessments/new";
      preLoaderRoute: typeof AppRegionAssessmentsNewRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/curves_/$chartKey": {
      id: "/_app/$region/curves_/$chartKey";
      path: "/curves/$chartKey";
      fullPath: "/$region/curves/$chartKey";
      preLoaderRoute: typeof AppRegionCurvesChartKeyRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/library/": {
      id: "/_app/$region/library/";
      path: "/library";
      fullPath: "/$region/library/";
      preLoaderRoute: typeof AppRegionLibraryIndexRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/library/$docUid": {
      id: "/_app/$region/library/$docUid";
      path: "/library/$docUid";
      fullPath: "/$region/library/$docUid";
      preLoaderRoute: typeof AppRegionLibraryDocUidRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/admin/datasets/": {
      id: "/_app/admin/datasets/";
      path: "/";
      fullPath: "/admin/datasets/";
      preLoaderRoute: typeof AppAdminDatasetsIndexRouteImport;
      parentRoute: typeof AppAdminDatasetsRoute;
    };
    "/_app/admin/datasets/activity": {
      id: "/_app/admin/datasets/activity";
      path: "/activity";
      fullPath: "/admin/datasets/activity";
      preLoaderRoute: typeof AppAdminDatasetsActivityRouteImport;
      parentRoute: typeof AppAdminDatasetsRoute;
    };
    "/_app/admin/datasets/files": {
      id: "/_app/admin/datasets/files";
      path: "/files";
      fullPath: "/admin/datasets/files";
      preLoaderRoute: typeof AppAdminDatasetsFilesRouteImport;
      parentRoute: typeof AppAdminDatasetsRoute;
    };
    "/_app/admin/datasets/new": {
      id: "/_app/admin/datasets/new";
      path: "/new";
      fullPath: "/admin/datasets/new";
      preLoaderRoute: typeof AppAdminDatasetsNewRouteImport;
      parentRoute: typeof AppAdminDatasetsRoute;
    };
    "/_app/admin/datasets/registry": {
      id: "/_app/admin/datasets/registry";
      path: "/registry";
      fullPath: "/admin/datasets/registry";
      preLoaderRoute: typeof AppAdminDatasetsRegistryRouteImport;
      parentRoute: typeof AppAdminDatasetsRoute;
    };
    "/_app/ops/jobs/": {
      id: "/_app/ops/jobs/";
      path: "/ops/jobs";
      fullPath: "/ops/jobs/";
      preLoaderRoute: typeof AppOpsJobsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ops/jobs/$jobId": {
      id: "/_app/ops/jobs/$jobId";
      path: "/ops/jobs/$jobId";
      fullPath: "/ops/jobs/$jobId";
      preLoaderRoute: typeof AppOpsJobsJobIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ops/runs/": {
      id: "/_app/ops/runs/";
      path: "/ops/runs";
      fullPath: "/ops/runs/";
      preLoaderRoute: typeof AppOpsRunsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ops/runs/$runUid": {
      id: "/_app/ops/runs/$runUid";
      path: "/ops/runs/$runUid";
      fullPath: "/ops/runs/$runUid";
      preLoaderRoute: typeof AppOpsRunsRunUidRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/$region/assessments/documents/$capabilityDocUid": {
      id: "/_app/$region/assessments/documents/$capabilityDocUid";
      path: "/assessments/documents/$capabilityDocUid";
      fullPath: "/$region/assessments/documents/$capabilityDocUid";
      preLoaderRoute: typeof AppRegionAssessmentsDocumentsCapabilityDocUidRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/$region/library/$docUid_/pdf": {
      id: "/_app/$region/library/$docUid_/pdf";
      path: "/library/$docUid/pdf";
      fullPath: "/$region/library/$docUid/pdf";
      preLoaderRoute: typeof AppRegionLibraryDocUidPdfRouteImport;
      parentRoute: typeof AppRegionRoute;
    };
    "/_app/admin/datasets/families/$familyId/": {
      id: "/_app/admin/datasets/families/$familyId/";
      path: "/families/$familyId";
      fullPath: "/admin/datasets/families/$familyId/";
      preLoaderRoute: typeof AppAdminDatasetsFamiliesFamilyIdIndexRouteImport;
      parentRoute: typeof AppAdminDatasetsRoute;
    };
    "/_app/admin/datasets/families/$familyId/versions/$versionLabel": {
      id: "/_app/admin/datasets/families/$familyId/versions/$versionLabel";
      path: "/families/$familyId/versions/$versionLabel";
      fullPath: "/admin/datasets/families/$familyId/versions/$versionLabel";
      preLoaderRoute: typeof AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRouteImport;
      parentRoute: typeof AppAdminDatasetsRoute;
    };
  }
}

interface AppRegionRouteChildren {
  AppRegionAssistantRoute: typeof AppRegionAssistantRoute;
  AppRegionCurvesRoute: typeof AppRegionCurvesRoute;
  AppRegionGlossaryRoute: typeof AppRegionGlossaryRoute;
  AppRegionParametersRoute: typeof AppRegionParametersRoute;
  AppRegionQualityRoute: typeof AppRegionQualityRoute;
  AppRegionSearchRoute: typeof AppRegionSearchRoute;
  AppRegionVersionsRoute: typeof AppRegionVersionsRoute;
  AppRegionWorkspaceRoute: typeof AppRegionWorkspaceRoute;
  AppRegionIndexRoute: typeof AppRegionIndexRoute;
  AppRegionAssessmentsAssessmentUidRoute: typeof AppRegionAssessmentsAssessmentUidRoute;
  AppRegionAssessmentsNewRoute: typeof AppRegionAssessmentsNewRoute;
  AppRegionCurvesChartKeyRoute: typeof AppRegionCurvesChartKeyRoute;
  AppRegionLibraryDocUidRoute: typeof AppRegionLibraryDocUidRoute;
  AppRegionAssessmentsIndexRoute: typeof AppRegionAssessmentsIndexRoute;
  AppRegionLibraryIndexRoute: typeof AppRegionLibraryIndexRoute;
  AppRegionAssessmentsDocumentsCapabilityDocUidRoute: typeof AppRegionAssessmentsDocumentsCapabilityDocUidRoute;
  AppRegionLibraryDocUidPdfRoute: typeof AppRegionLibraryDocUidPdfRoute;
}

const AppRegionRouteChildren: AppRegionRouteChildren = {
  AppRegionAssistantRoute: AppRegionAssistantRoute,
  AppRegionCurvesRoute: AppRegionCurvesRoute,
  AppRegionGlossaryRoute: AppRegionGlossaryRoute,
  AppRegionParametersRoute: AppRegionParametersRoute,
  AppRegionQualityRoute: AppRegionQualityRoute,
  AppRegionSearchRoute: AppRegionSearchRoute,
  AppRegionVersionsRoute: AppRegionVersionsRoute,
  AppRegionWorkspaceRoute: AppRegionWorkspaceRoute,
  AppRegionIndexRoute: AppRegionIndexRoute,
  AppRegionAssessmentsAssessmentUidRoute:
    AppRegionAssessmentsAssessmentUidRoute,
  AppRegionAssessmentsNewRoute: AppRegionAssessmentsNewRoute,
  AppRegionCurvesChartKeyRoute: AppRegionCurvesChartKeyRoute,
  AppRegionLibraryDocUidRoute: AppRegionLibraryDocUidRoute,
  AppRegionAssessmentsIndexRoute: AppRegionAssessmentsIndexRoute,
  AppRegionLibraryIndexRoute: AppRegionLibraryIndexRoute,
  AppRegionAssessmentsDocumentsCapabilityDocUidRoute:
    AppRegionAssessmentsDocumentsCapabilityDocUidRoute,
  AppRegionLibraryDocUidPdfRoute: AppRegionLibraryDocUidPdfRoute,
};

const AppRegionRouteWithChildren = AppRegionRoute._addFileChildren(
  AppRegionRouteChildren,
);

interface AppAdminDatasetsRouteChildren {
  AppAdminDatasetsActivityRoute: typeof AppAdminDatasetsActivityRoute;
  AppAdminDatasetsFilesRoute: typeof AppAdminDatasetsFilesRoute;
  AppAdminDatasetsNewRoute: typeof AppAdminDatasetsNewRoute;
  AppAdminDatasetsRegistryRoute: typeof AppAdminDatasetsRegistryRoute;
  AppAdminDatasetsIndexRoute: typeof AppAdminDatasetsIndexRoute;
  AppAdminDatasetsFamiliesFamilyIdIndexRoute: typeof AppAdminDatasetsFamiliesFamilyIdIndexRoute;
  AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRoute: typeof AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRoute;
}

const AppAdminDatasetsRouteChildren: AppAdminDatasetsRouteChildren = {
  AppAdminDatasetsActivityRoute: AppAdminDatasetsActivityRoute,
  AppAdminDatasetsFilesRoute: AppAdminDatasetsFilesRoute,
  AppAdminDatasetsNewRoute: AppAdminDatasetsNewRoute,
  AppAdminDatasetsRegistryRoute: AppAdminDatasetsRegistryRoute,
  AppAdminDatasetsIndexRoute: AppAdminDatasetsIndexRoute,
  AppAdminDatasetsFamiliesFamilyIdIndexRoute:
    AppAdminDatasetsFamiliesFamilyIdIndexRoute,
  AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRoute:
    AppAdminDatasetsFamiliesFamilyIdVersionsVersionLabelRoute,
};

const AppAdminDatasetsRouteWithChildren =
  AppAdminDatasetsRoute._addFileChildren(AppAdminDatasetsRouteChildren);

interface AppRouteChildren {
  AppRegionRoute: typeof AppRegionRouteWithChildren;
  AppAboutRoute: typeof AppAboutRoute;
  AppAccountRoute: typeof AppAccountRoute;
  AppAdminDatasetsRoute: typeof AppAdminDatasetsRouteWithChildren;
  AppAdminFeedbackRoute: typeof AppAdminFeedbackRoute;
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute;
  AppAdminUsersRoute: typeof AppAdminUsersRoute;
  AppOpsSourcesRoute: typeof AppOpsSourcesRoute;
  AppOpsSystemRoute: typeof AppOpsSystemRoute;
  AppOpsJobsJobIdRoute: typeof AppOpsJobsJobIdRoute;
  AppOpsRunsRunUidRoute: typeof AppOpsRunsRunUidRoute;
  AppOpsJobsIndexRoute: typeof AppOpsJobsIndexRoute;
  AppOpsRunsIndexRoute: typeof AppOpsRunsIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppRegionRoute: AppRegionRouteWithChildren,
  AppAboutRoute: AppAboutRoute,
  AppAccountRoute: AppAccountRoute,
  AppAdminDatasetsRoute: AppAdminDatasetsRouteWithChildren,
  AppAdminFeedbackRoute: AppAdminFeedbackRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppOpsSourcesRoute: AppOpsSourcesRoute,
  AppOpsSystemRoute: AppOpsSystemRoute,
  AppOpsJobsJobIdRoute: AppOpsJobsJobIdRoute,
  AppOpsRunsRunUidRoute: AppOpsRunsRunUidRoute,
  AppOpsJobsIndexRoute: AppOpsJobsIndexRoute,
  AppOpsRunsIndexRoute: AppOpsRunsIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SigninRoute: SigninRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
